<template>
  <b-modal
    centered
    header-class="popup_left_header"
    body-class="notify-body"
    content-class="notify-content"
    dialog-class="notify-dialog"
    :hide-footer="true"
    :visible="visible"
    @cancel="onCancel"
    @hide="onCancel"
  >
    <template #modal-header style="">
      <div class="dlg_title">{{item.f_title}}</div>
      <b-img class="mo_close_btn"  @click="onCancel" :src="require('../../../assets/image/ic_close2.png')"/>
    </template>
    <template v-if="item != null">
      <div class="body">
        <div class="row">
          <div class="caption_wrapper caption">{{$t("notify.site_name")}}</div>
          <div class="info_wrapper info">{{item.f_site_name}}</div>
          <b-button v-if="item.f_site_idx > 0"
                    @click="onCancel"
                    class="btn_text">
            {{$t("notify.site_info")}}
          </b-button>
        </div>
        <div class="row">
          <div class="caption_wrapper caption">{{$t("notify.location")}}</div>
          <div class="info_wrapper info">{{item.f_address}}</div>
          <b-button @click="onNavi"
                    class="btn_text">
            {{$t("interest.navi_connect")}}
          </b-button>
        </div>
        <div v-for="(it, i) in item.contacts_list"
             :key="i"
             class="row">
          <div class="caption_wrapper caption">{{it.f_name}}</div>
          <div class="info_wrapper phone">{{it.f_phone}}</div>
          <b-button @click="onCallPhone(it.f_phone, it.f_name)"
                    class="btn_text">
            {{$t("interest.call_phone")}}
          </b-button>
        </div>
        <div class="divider"/>
        <div class="center space_between" style="margin:10px;">
          <div class="caption1">{{' '}}</div>
          <div class="reg_time">{{item.f_reg_time}}</div>
        </div>
        <div class="content_wrapper">
          <div class="content_text" 
               v-html="replaceEnter(item.f_content)">
          </div>
          <CCarousel
            v-if="image_urls.length > 0"
            v-model="imgIndex"
            :interval="0"            
          >
            <b-carousel-slide
              v-for="image in image_urls"              
            >
              <template slot="img">
                <div class="slide-content" style="height: 300px;margin-top: 10px;">              
                  <b-img
                    style="max-width: 100%; max-height: 100%;"
                    @click="onGallery"
                    :src="image"
                  />
                </div>
              </template>
            </b-carousel-slide>
          </CCarousel>
        </div>
      </div>
    </template>
    <Gallery

      :visible.sync="galleryPopupShow"
      :src="image_urls"
      :current="imgIndex"
    />
    <SiteDetail
      v-if="siteInfo != null"
      :visible.sync="showSiteDetail"
      :site="siteInfo" />
  </b-modal>
</template>

<script>
import Utils from "../../../config/utils";
import Gallery from "../Gallery";
import CCarousel from "../CCarousel";

const u = require('util');
export default {
  name: "NotifyDetailPopup1",
  components:{
    Gallery,
    CCarousel,
  },
  props:{
    visible:{
      type:Boolean,
      default:false,
    },
    item:{
      type:Object,
      default:'',
    },
  },
  data() {
    return {
      self: this,
      u: Utils,
      siteInfo: null,
      notify: {},
      activeIndex: 0,
      current:1,
      image_urls:[],
      imgIndex:0,
      galleryPopupShow:false,
      showSiteDetail: false,
    }
  },
  inject: ["eventBus"],
  methods:{
    onCallPhone(phone, name){
      Utils.callPhone(this, phone, name);
    },
    onNavi(){
      //TODO: 네비연결기능실현해주세요.
      //Utils.onNavi(this, this.item.f_longitude, this.item.f_latitude, this.item.f_address1, this.item.f_name);
      Utils.onNavi(this, this.item.f_longitude, this.item.f_latitude, this.item.f_address1, this.item.f_address1);
    },
    onGallery(){
      this.galleryPopupShow = true;
    },
    onCancel(){
      this.$emit('update:visible', false);
    },
    replaceEnter(text){
      return text.replace(/\n/g, "<br>");
    },
  },
  watch:{
    item(){
      if (this.item !== null){
        if (this.image_urls != null)
          this.image_urls = this.item.f_image_url.split(',').filter(it => {
            return it !== '';
          });
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/_vars.scss";

 .dlg_title{
   color: $black;
   font-size: $fs_20;
   font-family: $korean_gd_14_r;
   padding-left: 0px;
   white-space: nowrap;
   text-overflow: ellipsis;
   overflow: hidden;
 };
 .body {
   padding: 20px 7px 10px 7px;
 }
 .row{
   display: flex;
   align-items: center;
   padding:0 10px;
   margin-bottom: 8px;
   height: 35px;
 }
 .caption_wrapper{width: 83px}
 .caption{color: $black; font-size: $fs_18; font-family: $korean_gd_14_r; width: 100px; margin-right:10px;padding-left: 10px;};
 .caption1{color: #a3a3a3; font-size: $fs_14; font-family: $korean_gd_13_r;}
 .info_wrapper{flex: 1; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;};
 .info{color: $black; font-size: $fs_18; font-family: $korean_gd_13_r};
 .phone{color: $black; font-size: $fs_18; font-family: $korean_gd_13_r};
 .btn{
   width: 72px;
   height: 33px;
   border-radius: 2px;
   background-color: $c_457fff;
   align-items: center;
   justify-content: center;
   margin-left: 10px;
   color: $white;
   font-size: $fs_14;
   font-family: $korean_gd_14_r;
   padding: 0;
 };

 .divider{
   width: 100%;
   height: 0.5px;
   margin-top: 20px;
   background-color: #dcdcdc
 }

 .reg_time{font-size: $fs_15; color: #a3a3a3; font-family: $korean_gd_13_r; };
 .content_wrapper{
   overflow: auto;
   border:solid 0.5px #dfdcdc;
   border-radius: 3px;
   padding: 10px;
   margin-top: 8px;
   height: 585px;
   word-break: break-all;
 };

 .content_text{
   color: $black; font-size: $fs_18; font-family: $korean_gd_13_r;  line-height: 30px;
 };
 .slide-item{
   height: 150px;
   //display: flex;
   //justify-content: center;
 }
 .content_img{width: 100%; height: 150px; margin-top: 0; margin-bottom: 20px};

 .content_wrapper::-webkit-scrollbar{
   height: 12px;
   width: 12px;
   background: #F0F0F0 ;
 }

 .content_wrapper::-webkit-scrollbar-thumb{
   background-color: #A8A8A8;
 }
</style>



// WEBPACK FOOTER //
// src/components/controls/popup/NotifyDetailPopup1.vue